import { useState } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <div>
      {/* Dark CTA panel */}
      <div id="cta-panel">
        <div className="cta-inner">
          <h2>Let's Build Your Network the Right Way</h2>
          <p>Tell us about your project. We'll design the right solution.</p>
          <div className="cta-actions">
            <a href="#contact" className="btn-primary page-scroll">
              Start Your Project
            </a>
            <a href="#contact" className="btn-outline-white page-scroll">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div id="contact">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-form-col">
              <div className="section-header">
                <h2>Get In Touch</h2>
                <p>Fill out the form and we'll get back to you within one business day.</p>
              </div>
              <form
                name="sentMessage"
                validate="true"
                action="https://formspree.io/f/myyqkpnd"
                method="POST"
              >
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-input"
                      placeholder="Your Name"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-input"
                      placeholder="Email Address"
                      required
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-input form-textarea"
                    rows="5"
                    placeholder="Tell us about your project..."
                    required
                    onChange={handleChange}
                  ></textarea>
                </div>
                <button type="submit" className="btn-primary">
                  Send Message
                </button>
              </form>
            </div>

            <div className="contact-info-col">
              <h3>Contact Information</h3>
              <div className="contact-detail">
                <span className="contact-detail-label">Address</span>
                <span>{props.data ? props.data.address : "loading"}</span>
              </div>
              <div className="contact-detail">
                <span className="contact-detail-label">Phone</span>
                <a href={`tel:${props.data ? props.data.phone : ""}`}>
                  {props.data ? props.data.phone : "loading"}
                </a>
              </div>
              <div className="contact-detail">
                <span className="contact-detail-label">Email</span>
                <a href={`mailto:${props.data ? props.data.email : ""}`}>
                  {props.data ? props.data.email : "loading"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div id="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src="/img/logo-white.png" alt="Enteranet" className="footer-logo" />
            <p>Engineering Reliable Connectivity.</p>
          </div>
          <div className="footer-links">
            <a href="#about" className="page-scroll">About</a>
            <a href="#services" className="page-scroll">Solutions</a>
            <a href="#portfolio" className="page-scroll">Projects</a>
            <a href="/government-contracts">Gov Contracts</a>
            <a href="#contact" className="page-scroll">Contact</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Enteranet LLC. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};
